// extracted by mini-css-extract-plugin
export default {"discount":"nv","order_summary":"ov","line_item":"pv","separator":"qv","order__summary_item_title":"rv","recurringdis":"sv","get_it_now_button":"tv"};
    if(module.hot) {
      // 1738836192893
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  